<template>
  <!-- <ScreenAdapter>

  </ScreenAdapter> -->
  <div class="fff">
    <Aside></Aside>
    <Header />
    <div class="container">
      <div class="thought-content" ref="226" v-if="dshgData && dshgData.length > 0">
        <!-- 党史回顾 -->
        <div class="content-header">
          <div class="text">党史回顾</div>
        </div>
        <div class="content-box">
          <div class="thought-bg">
            <div class="thought-content">
              <div class="swiper-content">
                <swiper :options="thoughtSwiperOption">
                  <swiper-slide v-for="item in dshgData.slice(0,4)" :key="item.id" :data-id="item.id">
                    <div class="c-img" :data-id="item.id" :style="`background:url('${item.photo}') no-repeat center/cover;`"></div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-pagination thought"></div>

                <div class="swiper-button-next thought"></div>
                <div class="swiper-button-prev thought"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 国史漫谈 -->
      <div class="history-content" v-if="gsmtData&&gsmtData.length>0">
        <div class="content-header" ref="227">
          <div class="text">国史漫谈</div>
        </div>
        <div class="content-box">
          <div class="swiper">
            <swiper :options="swiperOption2">
              <swiper-slide v-for="item,index in gsmtData" :key="index">
                <div class="cover" :style="`background:url(${item.photo}) no-repeat center/cover;`" @click="jumpDetail(item)"></div>
              </swiper-slide>
            </swiper>
            <template v-if="gsmtData&&gsmtData.length>3">
              <div class="b swiper-pagination" slot="pagination"></div>
              <div class="b swiper-button-next">
              </div>
              <div class="b swiper-button-prev">
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- 重话改革开放 -->
      <div class="pioneer-content" v-if="chggkfData&&chggkfData.length>0">
        <div class="content-header" ref="228">
          <div class="text">重话改革开放</div>
        </div>
        <div class="content-box">
          <div class="cover-item" v-for="item,index in chggkfData.slice(0,2)" :key="index" @click="jumpDetail(item)">
            <div class="thumb-image">
              <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`">

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 重温社会主义 -->
      <div class="century-content" v-if="cwshzyData&&cwshzyData.length">
        <div class="content-header" ref="229">
          <div class="text">重温社会主义</div>
        </div>
        <div class="content-box">
          <div class="big-cover" @click="jumpDetail(cwshzyData[0])">
            <div class="c-img" :style="`background:url(${cwshzyData[0].photo}) no-repeat center/cover;`">

            </div>
          </div>
          <div class="sub-cover">
            <div class="cover-item" v-for="item,index in cwshzyData.slice(1)" :key="index" @click="jumpDetail(item)">
              <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Custom/Party/Header"
import Footer from "@/components/Custom/Party/Footer"
// import ScreenAdapter from "@/components/ScreenAdapter"
import utils from "../../../../config/utils"
import services from '@/config/services'
import Aside from "../../../../components/Custom/Party/Aside.vue"
export default {
  data () {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      thoughtSwiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 300,
          depth: 150,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.thought`,
          prevEl: `.swiper-button-prev.thought`,
        },
        pagination: {
          el: `.swiper-pagination.thought`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-id");
            if (id) {
              window.open(`/center/${that.school_code}/custom/party/detail?id=${id}&key=learn`, "_blank")
            }

          },
        },
      },
      swiperOption2: {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        dynamicBullets: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 41,
        pagination: {
          el: ".b.swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".b.swiper-button-next",
          prevEl: ".b.swiper-button-prev",
        },
        // loop: true,
      },
      dshgData: [],
      gsmtData: [],
      chggkfData: [],
      cwshzyData: [],
    }
  },
  async mounted () {
    await this.getListData()
    await this.jumpPosition()
  },
  methods: {
    // 跳转到课程详情
    jumpDetail (item, key) {
      window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}&key=learn`, "_blank")
    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          document.body.scrollTop = topVal - 100
        })
      }
    },
    async getListData () {
      await services.getCourseList({ page: 1, size: 100, category_id: "226", school_code: this.school_code }).then(res => {
        this.dshgData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 100, category_id: "227", school_code: this.school_code }).then(res => {
        this.gsmtData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 2, category_id: "228", school_code: this.school_code }).then(res => {
        this.chggkfData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 3, category_id: "229", school_code: this.school_code }).then(res => {
        this.cwshzyData = res.data.items
      })
    }
  },
  components: {
    Header,
    Footer,
    Aside,
    // ScreenAdapter
  }
}
</script>

<style  lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
.container {
    width: 1200px;
    margin: 0 auto;
    padding: 70px 0 50px;
    .content-header {
        width: 100%;
        height: 25px;
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url('../../../../assets/custom/party/index/list-title.png')
            no-repeat center / cover;
        .text {
            font-size: 42px;
            font-weight: bold;
            background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    .c-img {
        width: 100%;
        height: 100%;
        transition: all 0.7s;
    }

    .thought-content {
        position: relative;
        &::before {
            content: '';
            display: inline-block;
            width: 100vw;
            top: -380px;
            left: 50%;
            transform: translateX(-50%);
            height: 1322px;
            position: absolute;
            background: url('../../../../assets/hzvtc/list/value-t-bg.png')
                no-repeat center/cover;
        }

        .content-box {
            .swiper-slide {
                width: 740px !important;
                height: 416px !important;
                overflow: hidden;
                &:hover {
                    .cover,
                    .c-img {
                        transform: scale(1.2);
                    }
                }
                .cover,
                .c-img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.7s;
                }
            }

            ::v-deep .swiper-pagination {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                bottom: -32px;
                left: 50%;
                transform: translateX(-50%);
            }
            ::v-deep .swiper-pagination-bullet {
                width: 7px;
                height: 7px;
                background: #b61e2a;
                border: 1px solid #ffffff;
                opacity: 0.5;
                border-radius: 50%;
                display: block;
                transition: all 0.3s;
                margin-right: 4px;
            }

            ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
                width: 13px;
                height: 7px;
                background: #b61e2a;
                border: 1px solid #ffffff;
                border-radius: 3px;
                opacity: 1;
                margin-right: 7px;
            }
        }
    }
    .thought-bg {
        background-position: center;
        background-size: cover;
        padding: 40px 0;
        .thought-content {
            width: 1200px;
            margin: 0 auto;
            .swiper-content {
                position: relative;
                width: 100%;
                height: 465px;
                display: flex;
                align-items: center;
                .swiper-container {
                    height: 100%;
                    .swiper-wrapper {
                        .swiper-slide {
                            width: 740px;
                            height: 416px;
                            background: #fff;
                            background-size: 100% auto;
                            background-position: center;
                            cursor: pointer;
                            &.swiper-slide-active {
                                -webkit-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -moz-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -o-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                -ms-transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                transform: translate3d(0px, 0px, 0px)
                                    rotateX(0deg) rotateY(0deg) !important;
                                border: 2px solid red;
                            }
                        }
                    }
                }
                /deep/ .swiper-pagination {
                    bottom: 10px;
                    width: 100%;
                    .swiper-pagination-bullet {
                        width: 10px;
                        height: 10px;
                        background: #ffbe8f;
                        border-radius: 50%;
                        margin: 0 5px;
                    }
                    .swiper-pagination-bullet.swiper-pagination-bullet-active {
                        width: 10px;
                        height: 10px;
                        background: #b70000;
                        border-radius: 50%;
                    }
                }
                .swiper-button-next,
                .swiper-button-prev {
                    flex-shrink: 0;
                    background-size: cover;
                    z-index: 100;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                }
                .swiper-button-prev {
                    left: -84px;
                    background: url('../../../../assets/hzvtc/list/value-prev.png')
                        no-repeat center/cover;
                }
                .swiper-button-next {
                    right: -84px;
                    background: url('../../../../assets/hzvtc/list/value-next.png')
                        no-repeat center/cover;
                }
            }
        }
    }

    .history-content {
        .content-header {
            margin-bottom: 35px;
        }
        .content-box {
            .swiper {
                position: relative;
                .swiper-slide {
                    width: 380px;
                    height: 214px;
                    overflow: hidden;
                    &:hover {
                        .cover {
                            transform: scale(1.2);
                        }
                    }
                }
                .cover {
                    width: calc(100%);
                    height: 100%;
                    cursor: pointer;
                    transition: all 0.7s;
                }
                ::v-deep .swiper-pagination {
                    margin-top: 24px;
                    display: flex;
                    justify-content: center;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    background: #cdb29f;
                    border-radius: 50%;
                    display: block;
                    cursor: pointer;
                    &:not(:last-child) {
                        margin-right: 15px;
                    }
                }
                ::v-deep
                    .swiper-pagination-bullet.swiper-pagination-bullet-active {
                    background: #dd3639;
                }
                ::v-deep .swiper-button-next,
                ::v-deep .swiper-button-prev {
                    width: 17px;
                    height: 32px;
                    cursor: pointer;
                    display: block;
                }
                ::v-deep .swiper-wrapper {
                    position: unset !important;
                }
                ::v-deep .swiper-button-prev {
                    background: url('../../../../assets/hzvtc/list/swiper-prev.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    left: -24px;
                }

                ::v-deep .swiper-button-next {
                    background: url('../../../../assets/hzvtc/list/swiper-next.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    right: -24px;
                }
            }
        }
    }

    .pioneer-content {
        margin-bottom: 60px;
        position: relative;

        .content-header {
            margin: 70px 0 33px;
        }
        .content-box {
            display: flex;
            justify-content: space-between;
            .cover-item {
                width: 580px;
                height: 387px;
                background: #b61e2a;
                border: 1px solid #e8d9c5;
                padding: 30px 0;
                cursor: pointer;
                .thumb-image {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    &:hover {
                        .c-img {
                            transform: scale(1.2);
                        }
                    }
                }
            }
        }
    }
    .century-content {
        .content-header {
            margin-bottom: 32px;
        }
        .content-box {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            .big-cover {
                width: 785px;
                height: 442px;
            }
            .big-cover,
            .sub-cover .cover-item {
                overflow: hidden;
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
            .sub-cover {
                flex: 1;
                margin-left: 43px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .cover-item {
                    width: 100%;
                    height: 208px;
                    cursor: pointer;
                }
            }
        }
    }
}
.fff {
    background: #fff;
}
</style>